import { render, staticRenderFns } from "./SiteComponent.vue?vue&type=template&id=d2310032&scoped=true&"
import script from "./SiteComponent.vue?vue&type=script&lang=js&"
export * from "./SiteComponent.vue?vue&type=script&lang=js&"
import style0 from "./SiteComponent.vue?vue&type=style&index=0&id=d2310032&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2310032",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow})
